"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAvgPipe = void 0;
class GetAvgPipe {
    transform(items, attr, wholeNum = false) {
        if (items != null) {
            const sum = items.reduce((a, b) => a + b[attr], 0);
            return wholeNum ? Math.ceil(sum / items.length) : (sum / items.length).toFixed(2);
        }
    }
}
exports.GetAvgPipe = GetAvgPipe;
//# sourceMappingURL=getAverage.pipe.js.map